var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "login-page", attrs: { id: "page_Container" } },
      [
        _c("div", { staticClass: "page" }, [
          _c("div", {
            staticClass: "main-container",
            attrs: { id: "main-container" }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }